import React, { ReactNode } from 'react';
import { I18n, Translate } from 'react-redux-i18n';
import { Field } from 'react-final-form';
import TextInput from '../../../../common/inputs/TextInput';
import image from '../../../../../img/structure-pro/contact.svg';
import camera from '../../../../../img/icones/camera2.svg';
import { validateEmail, validatePhone, validateUrl } from '../../../../../services/utils';
import PicturePopin from '../../../../external/PicturePopin';

type Props = {
  logo: string
  getDisplayedError: (fieldName: string) => string
  isManager: boolean
};

type State = {
  openImagePopin: boolean,
  newImage?: string,
};

class StructureContact extends React.Component<Props, State> {
  state: State = {
    openImagePopin: false,
    newImage: this.props.logo,
  };

  toogleImagePopin = (): void => {
    this.setState((previousState) => ({ openImagePopin: !previousState.openImagePopin }));
  };

  render(): ReactNode {
    return (
      <div className="structure-container structure-contact">
        <div className="structure-illustration-container">
          <div className="structure-illustration container-img">
            <img
              className="structure-illustration"
              src={this.state.newImage || image}
              alt="ILLUSTRATION"
            />
            {this.props.isManager
            && (
            <Field name="logo">
              {({
                input: {
                  value,
                  id = 'logo',
                  onChange, ...input
                },
              }) => (
                <>
                  <button
                    type="button"
                    onClick={this.toogleImagePopin}
                    disabled={!this.props.isManager}
                  >
                    <label htmlFor="logo" className="add-photo-label">
                      <img
                        className="add-foto"
                        src={camera}
                        alt="add-foto"
                      />
                    </label>
                  </button>
                  <PicturePopin
                    isOpen={this.state.openImagePopin}
                    onClose={this.toogleImagePopin}
                    image={this.state.newImage || image}
                    imageChanged={((image1) => {
                      onChange(image1);
                      this.setState({ newImage: image1 });
                    })}
                  />
                </>
              )}
            </Field>
            )}
          </div>
        </div>
        <div className="structure-drawer-title-container">
          <div className="structure-drawer-title">
            <Translate value="STRUCTURE_INFORMATION.STRUCTURE_CONTACT" />
          </div>
          <div className="structure-contact-form">
            <Field
              name="phoneNumber"
              component={TextInput}
              placeholder={I18n.t('STRUCTURE_INFORMATION.TELEPHONE')}
              type="text"
              validate={validatePhone}
              customError={this.props.getDisplayedError('phoneNumber')}
              readOnly={!this.props.isManager}
            />
            <Field
              name="email"
              component={TextInput}
              placeholder={I18n.t('STRUCTURE_INFORMATION.EMAIL')}
              type="text"
              validate={validateEmail}
              customError={this.props.getDisplayedError('email')}
              readOnly={!this.props.isManager}
            />
            <Field
              name="siteInternet"
              component={TextInput}
              placeholder={I18n.t('STRUCTURE_INFORMATION.SITE')}
              type="text"
              validate={validateUrl}
              customError={this.props.getDisplayedError('siteInternet')}
              readOnly={!this.props.isManager}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default StructureContact;
